var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgKanbanViewi = function SvgKanbanViewi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none",
    opacity: 0.08,
    rx: 3
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M6.5 18a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5zm7-4a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5z",
    "data-name": "Union 5"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKanbanViewi);
export default ForwardRef;